<div class="send-money">
    <div class="row m-0">
        <div class="col-md-6 head-top">
            <h5 class="sm-18 color-blue mb-4 font-weight-bold ">Select a bill to pay</h5>
            <div  class="card  border-0 my-2 cursor-pointer" style="border-radius: 5px;"  *ngFor="let biller of billers" [ngClass] = "{'bg-primary' : selectedBiller==biller}">
                <div class="card-body row">
                    <div class="col-10 d-flex flex-wrap" (click)="selectBiller(biller)">  
                        <div class="col-10 col-md-8" >
                            <h5 class=" sm-16 color-royalblue gilroy-bold"> {{biller.nick_name ? biller.nick_name : 'Nick Name'}} </h5>
                        </div>
                        <div class="col-2 col-md-4">
                            <!-- <img *ngIf="selectedBiller==biller" src="assets/images/check.png"> -->
                            <button class="btn select-btn sm-10 h-auto primary-text">{{selectedBiller==biller?'Selected':'Select'}}</button>
                        </div>
                        <div class="custom-text-font color-lightgray sm-10 col-12">
                            {{ biller.biller_name }} {{ biller.biller_input_1_name }} ending in {{ biller.biller_input_1%10000 ? biller.biller_input_1%10000 : biller.biller_input_1}}
                        </div>
                    </div>
                    
                    <div class="col-2">
                        <i class="far fa-trash-alt text-danger pt-2" title="Remove Biller" (click)="confirmDelete(biller.id)"></i >
                    </div>
                </div>
            </div>
            <p-confirmDialog></p-confirmDialog>
            <div class="w-100 d-flex align-items-center justify-content-center justify-content-md-end my-2" *ngIf="!show()">
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="getBillers(+current_page-1)" [disabled]='prev_disabled'>
                    <i class="fas fa-arrow-left mr-1"></i> Previous
                </button>
                <span class="col-2 text-center sm-10 gilroy-bold color-blue">{{ current_page }}/{{last_page}}</span>
                <button class="btn bg-alice sm-10 color-blue col-4 col-md-3 gilroy-bold" (click)="getBillers(+current_page+1)" [disabled]='next_disabled'>
                    Next <i class="fas fa-arrow-right ml-1"></i>

                </button>
            </div>
            <div class="card  border-0 mt-3" style="border-radius: 5px;">
                <div class="card-body">
                   <app-add-biller (onBillerAdded)="getBillers(1)"></app-add-biller>
                </div>
            </div>
            
            <div class="div d-flex  my-3 address_field">
                <a href="" class="link sm-12 back-btn text-center">Cancel</a>
                <button class="btn btn-primary w-100" [disabled]="!selectedBiller" (click) = "checkAndProceed()" >Next</button>
            </div>
        </div>
    </div>
</div>